import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const notificationService = inject(NotificationService);
  const translateService = inject(TranslateService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const title = translateService.instant(error.status === 401 ? 'Unauthorized' : 'Error');
      let message = error.error?.message || error.message || 'An unexpected API error occurred.';
      if (message === 'PROPOSAL_FORCE_REFRESH') {
        message = 'Proposal was updated. Will refresh data, please review it.';
      }

      const showError =
        (
          message === 'NO_TOKEN' ||
          message === 'TOKEN_EXPIRED' ||
          message === 'INSUFFICIENT_STOCK' ||
          message === 'File not found' ||
          // Account-validation failures are handled in-page by the validate-account
          // component (resend panel / invalid-link state / redirect), so suppress the
          // generic global toast for them.
          message === 'VALIDATION_TOKEN_EXPIRED' ||
          message === 'ACCOUNT_ALREADY_VALIDATED' ||
          message === 'INVALID_VALIDATION_TOKEN'
        ) ?
          false
        : true;
      if (showError) {
        notificationService.error(title, translateService.instant(message));
      }

      return throwError(() => error?.error ?? message);
    })
  );
};
